export default __webpack_public_path__ + "static/media/klas.2562ceef.jpg";